import { PiSpinnerLight } from "react-icons/pi";

export const ProcessIcon = ({ style, ...rest }) => {
  return (
    <PiSpinnerLight
      {...rest}
      style={{ animation: "spin 1s linear infinite", ...style }}
    />
  );
};
